import { Form } from "@redriver/cinnamon-mui";
import { industriesLookup } from "modules/lookups";

const IndustryCheckboxGroup = (props) => (
  <Form.CheckboxGroup lookup={industriesLookup} {...props} />
);

export default IndustryCheckboxGroup;
